var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5703 15.4297H3.85603C3.14717 15.4297 2.57031 16.0065 2.57031 16.7154C2.57031 17.4243 3.14717 18.0011 3.85603 18.0011H17.5703C18.2792 18.0011 18.856 17.4243 18.856 16.7154C18.856 16.0065 18.2792 15.4297 17.5703 15.4297Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7143 2.57143C18.7689 2.57143 18 3.3403 18 4.28571C18 4.92087 18.3514 5.47027 18.8666 5.76684C17.8749 8.1154 16.3277 9.55626 14.8817 9.42598C13.2737 9.29485 11.9622 7.39369 11.2388 4.21285C12.1662 3.97797 12.8571 3.14226 12.8571 2.14286C12.8571 0.960854 11.8962 0 10.7142 0C9.53224 0 8.57139 0.960854 8.57139 2.14286C8.57139 3.1423 9.26225 3.97801 10.1897 4.21285C9.46624 7.39369 8.15479 9.29485 6.54681 9.42598C5.10682 9.55626 3.55279 8.1154 2.56197 5.76684C3.07709 5.47027 3.42853 4.92083 3.42853 4.28571C3.42853 3.3403 2.65965 2.57143 1.71424 2.57143C0.768876 2.57143 0 3.3403 0 4.28571C0 5.16516 0.668555 5.88344 1.52227 5.98112L3.17314 14.5714H18.2554L19.9063 5.98112C20.76 5.88344 21.4286 5.16516 21.4286 4.28571C21.4286 3.3403 20.6597 2.57143 19.7143 2.57143Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullSite);
export default __webpack_public_path__ + "static/media/full-site.50e7a9272f6b16a3225bb0eba0b01364.svg";
export { ForwardRef as ReactComponent };